import { render, staticRenderFns } from "./TrafficRequestActions.vue?vue&type=template&id=f50e3d8c&scoped=true"
import script from "./TrafficRequestActions.vue?vue&type=script&lang=ts"
export * from "./TrafficRequestActions.vue?vue&type=script&lang=ts"
import style0 from "./TrafficRequestActions.vue?vue&type=style&index=0&id=f50e3d8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50e3d8c",
  null
  
)

export default component.exports